/**
 * @packageDocumentation
 * @module f1/array
 */

export interface Head {
  /**
   * Returns the first item of an array as a new array
   *
   * @public
   * @note the spread is half the speed of a simple reference
   * @function f1.flatten
   * @param arr the array of arrays to flatten
   * @example
   *
   * ```ts
   * head([1, 2, 3]) => [1]
   * ```
   *
   */
  <T>(arr: T[]): T[];
}

/**
 * @see Head
 */
export default <T>(arr: T[]) => [arr[0]];
